import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { isPublicPageData } from './lib/publicPage';
import type { PublicPageData } from './lib/publicPage';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';

function readPublicPageData(): PublicPageData | null {
  const seed = document.getElementById('public-page-data');
  if (!seed) return null;
  try {
    const data: unknown = JSON.parse(seed.textContent || '');
    if (!isPublicPageData(data) || data.path !== window.location.pathname) return null;
    return data;
  } catch {
    return null;
  }
}

const initialData = readPublicPageData();
const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <ErrorBoundary>
          <App initialData={initialData} />
        </ErrorBoundary>
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <ErrorBoundary>
          <App initialData={initialData} />
        </ErrorBoundary>
      </HelmetProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
